<template>
  <div id='problem'>
    <h2>Prime Power Triples</h2>
    <a href="https://projecteuler.net/problem=87">https://projecteuler.net/problem=87</a>
    <h3>Thoughts</h3>
    <p>
      Straightforward problem. Use a sieve to generate all the primes (many examples of this, <a
        href="/projects/euler/7">problem 7</a> was the first usage), then build lists of all the powers of those primes
      which are less than the limit, then loop over the lists and put the results in a set to avoid potential duplicates.
    </p>
  </div>
</template>

<script>

export default {
  name: 'P087Page',
  components: {},
}

</script>

<style scoped>
div#problem {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-flow: column;
  text-align: left;
  font-size: 1.5rem;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25rem;
  max-width: 90ch;
}
</style>
